import React from "react";
import {
  cn,
  formFieldClass,
  formFieldErrorClass,
  formFieldHintClass,
  formFieldLabelClass,
} from "./formStyles";

const FormField = ({
  label,
  htmlFor,
  required = false,
  error,
  hint,
  className = "",
  children,
}) => (
  <div className={cn(formFieldClass, className)}>
    {label ? (
      <label htmlFor={htmlFor} className={formFieldLabelClass}>
        {label}
        {required ? " *" : ""}
      </label>
    ) : null}

    {children}

    {error ? <p className={formFieldErrorClass}>{error}</p> : null}
    {!error && hint ? <p className={formFieldHintClass}>{hint}</p> : null}
  </div>
);

export default FormField;
